import React, { useContext, useEffect, useState } from 'react'
import { Footer, Header, HeaderB2B } from 'components'
import { Context } from 'helpers/language-provider'
import { FormattedMessage } from 'react-intl'
import { StarRating } from 'common'

import { ArrowRight, ElectrumLogo, Thunder } from 'assets/icons'
import { AboutUsKV, AboutUsKV2, AboutUsSpirit, AboutUsSpirit2, ElectrumYear, IntroProduct, Mileage, Mission1, Mission2, Mission3, Placeholder1, Placeholder2, Placeholder3, ProvenQuality, ProvenQuality2, Reviewer1, Reviewer2, Reviewer3, Riders, Showroom, Swaps } from 'assets/images'
import Lottie from 'react-lottie'
import { Timeline } from 'assets/lottie'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'

const AboutUs = () => {
  // COLORED TEXT
  const ColoredText = styled.span`
    background: linear-gradient(0deg, #0B4571, #1ECECA);
    color: transparent;
    background-clip: text;
    font-family: Gilroy-Bold;
    font-size: 2rem;
  `

  const pageMeta = {
    title: 'Tentang Electrum',
    description: 'Electrum adalah pengembang motor listrik terdepan di Indonesia. Berkomitmen mengembangkan ekosistem energi yang terkoneksi dan terintegrasi.',
    keywords: 'electrum, tentang kami, motor listrik Indonesia, EV Indonesia, ekosistem kendaraan listrik',
  };

  return (
    <div style={{ backgroundColor: '#EBF0F5' }}>
      <Helmet>
        <title>{pageMeta?.title}</title>
        <meta name="title" content={pageMeta?.title} />
        <meta name="description" content={pageMeta?.description} />
        <meta name="keywords" content={pageMeta?.keywords} />
        <meta property="og:title" content={pageMeta?.title} />
        <meta property="og:description" content={pageMeta?.description} />
        <link rel="canonical" href="https://electrum.id/about-us" />
      </Helmet>

      <HeaderB2B />

      {/* PAGE KV */}
      <div style={{
        width: '100vw',
        height: '90vh',
        margin: '0rem auto',
        backgroundColor: 'white',
      }}>
        <div
          alt="Banner Placeholder"
          style={{
            backgroundImage: `url('${AboutUsKV}')`,
            backgroundSize: 'cover',
            width: '100vw',
            height: '100%',
            scrollSnapAlign: 'start',
          }}
        >
          {/* <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: '5rem' }}>
            <div style={{ fontFamily: 'Gilroy-Bold', color: 'white', fontSize: '5.5rem' }}>
              KV Here
            </div>
            <div style={{ fontFamily: 'Gilroy-SemiBold', color: 'white', fontSize: '2.5rem' }}>
              Can Show
            </div>
          </div> */}
        </div>
      </div>

      {/* ABOUT US */}
      <div style={{ padding: '10rem 12.5rem 12.5rem 12.5rem' }}>
        <div style={{ fontFamily: 'Gilroy-ExtraBold', fontSize: '3.125rem', color: '#103856', paddingLeft: '5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
          Tentang Electrum {' '}
          <span style={{ marginLeft: '2rem' }}>
            <ElectrumLogo height={70} />
          </span>
        </div>
        <div style={{ fontFamily: 'Gilroy-SemiBold', fontSize: '1.25rem', color: '#71869C', paddingLeft: '5rem', marginBottom: '3.5rem', borderLeft: '0.5rem solid #1ECECA' }}>
          Mengoptimalkan sinergi GoTo Group dan TBS Energi Utama, Electrum bergerak sebagai pemimpin dalam upaya elektrifikasi dan pembangunan ekosistem kendaraan listrik roda dua di Indonesia. Electrum memiliki komitmen untuk mengembangkan desain battery pack, sistem pertukaran baterai, stasiun swap, motor listrik, serta sistem IoT yang terintegrasi secara menyeluruh.
        </div>
        <img loading='lazy'  alt='rectangle-placeholder' src={AboutUsKV2} style={{ width: '100%' }} />
      </div>

      {/* MISSION */}
      <div style={{ padding: '6rem 12.5rem', backgroundColor: 'white', borderRadius: '1.125rem' }}>
        <div style={{ fontFamily: 'Gilroy-ExtraBold', fontSize: '3.5rem', textAlign: 'center', marginBottom: '1.25rem' }}>
          Misi Electrum
        </div>
        <div style={{ fontFamily: 'Gilroy-SemiBold', fontSize: '1rem', color: '#71869C', textAlign: 'center', lineHeight: '1.5' }}>
          Upaya kami untuk memberikan solusi transportasi bersih yang berkualitas didasari oleh niat pelayanan kami untuk menjaga lingkungan dan masyarakat di sekitar kami, serta berkontribusi bagi kemandirian energi Indonesia dan inisiatif iklim nasional.
        </div>
        <div style={{ display: 'flex', columnGap: '2.5rem', margin: '3.5rem 0 8.5rem 0' }}>
          <div style={{ width: '30%' }}>
            <img loading='lazy'  src={Mission1} alt='howto1' style={{ width: '100%' }} />
          </div>
          <div style={{ width: '30%' }}>
            <img loading='lazy'  src={Mission2} alt='howto1' style={{ width: '100%' }} />
          </div>
          <div style={{ width: '30%' }}>
            <img loading='lazy'  src={Mission3} alt='howto1' style={{ width: '100%' }} />
          </div>
        </div>
        <div style={{ fontFamily: 'Gilroy-SemiBold', fontSize: '1rem', color: '#71869C', textAlign: 'center', lineHeight: '1.5', marginBottom: '2.5rem' }}>
          Semangat Electrum adalah untuk mengkatalisasi pertumbuhan ekosistem kendaraan listrik di Indonesia, dan mendukung pengembangan sumber daya lokal guna memastikan solusi yang bermakna, relevan dan kredibel dalam membangun sistem mobilitas yang berkualitas dan terjangkau bagi bangsa dan generasi mendatang.
        </div>
        <img loading='lazy'  alt='aboutus-spirit' src={AboutUsSpirit2} style={{ width: '100%' }} />
      </div>

      {/* ELECTRUM BY YEAR */}
      <div style={{ margin: '10rem 0' }}>
        <div style={{ backgroundColor: 'white', borderRadius: '1.125rem', padding: '3.5rem 0' }}>
          <div style={{ fontFamily: 'Gilroy-Bold', fontSize: '3.25rem', textAlign: 'center' }}>
            Electrum dalam Tahun
          </div>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: Timeline,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
              }
            }}
            style={{
              borderRadius: '2.5rem',
              width: '100%',
            }}
          />
        </div>
      </div>

      {/* TRUST */}
      <div style={{ padding: '0rem 12.5rem 0rem 12.5rem' }}>
        <div style={{ fontFamily: 'Gilroy-ExtraBold', fontSize: '3.375rem', color: '#103856', textAlign: 'center' }}>
          Terbukti dan Terpercaya
        </div>
        <div style={{ fontFamily: 'Gilroy-SemiBold', fontSize: '1.25rem', color: '#71869C', textAlign: 'center', marginTop: '1.5rem' }}>
          Electrum berhasil membuktikan sebagai penyedia solusi mobilitas roda dua yang berkualitas, efisien, dan ramah lingkungan.
        </div>
        <img loading='lazy'  src={ProvenQuality2} alt='proven-quality' style={{ width: '100%', marginTop: '1.5rem' }} />
      </div>

      {/* DETAIL CARDS */}
      <div style={{ backgroundColor: 'white', borderRadius: '1.125rem', marginTop: '-2.25rem' }}>
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '4rem' }}>
          <div style={{
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 3px 15px 0px rgba(60, 223, 219, 1)',
            padding: '2rem 3rem',
            borderRadius: '1.25rem',
            display: 'flex',
            columnGap: '3rem',
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '0.2rem' }}>
              <ColoredText>
                3.000+
              </ColoredText>
              <div style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.25rem', color: '#103856' }}>
                Motorcycle OTR
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '0.2rem' }}>
              <ColoredText>
                20 million
              </ColoredText>
              <div style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.25rem', color: '#103856' }}>
                Kilometer Journey
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '0.2rem' }}>
              <ColoredText>
                250
              </ColoredText>
              <div style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.25rem', color: '#103856' }}>
                Total BSS
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '0.2rem' }}>
              <ColoredText>
                1 GWh
              </ColoredText>
              <div style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.25rem', color: '#103856' }}>
                Electricity Consumption
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: '0.2rem' }}>
              <ColoredText>
                830 ton
              </ColoredText>
              <div style={{ fontFamily: 'Gilroy-Bold', fontSize: '1.25rem', color: '#103856' }}>
                CO2e Savings
              </div>
            </div>
          </div>
        </div>
        <div style={{ padding: '4rem 12.5rem 7.5rem 12.5rem', display: 'flex', justifyContent: 'center', columnGap: '2.5rem', flexWrap: 'wrap' }}>
          <img loading='lazy'  alt='mileage' src={Mileage} style={{ maxWidth: 'calc(33% - 1.75rem)', flex: '1 1 auto' }} />
          <img loading='lazy'  alt='riders' src={Riders} style={{ maxWidth: 'calc(33% - 1.75rem)', flex: '1 1 auto' }} />
          <img loading='lazy'  alt='swaps' src={Swaps} style={{ maxWidth: 'calc(33% - 1.75rem)', flex: '1 1 auto' }} />
        </div>
      </div>

      {/* CENTER */}
      <div style={{ padding: '5rem 12.5rem', marginBottom: '6rem', backgroundColor: 'white', borderRadius: '1.125rem', marginTop: '10rem' }}>
        <div style={{ fontFamily: 'Gilroy-ExtraBold', fontSize: '3.5rem', color: '#103856', textAlign: 'center', marginBottom: '3rem' }}>
          Showroom & Service Center
        </div>
        <img loading='lazy'  alt='showroom' src={Showroom} style={{ width: '100%', marginBottom: '2rem' }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '3rem' }}>
          {/* LEFT */}
          <div style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}>
            <div style={{ fontFamily: 'Gilroy-SemiBold', fontSize: '1.125rem', color: '#71869C' }}>
              Kunjungi Electrum untuk rasakan ekosistem kendaraan motor listrik terlengkap.
            </div>
            <div style={{ display: 'flex', columnGap: '1.5rem' }}>
              <div>
                <button
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#0B4571',
                    border: 'none',
                    color: 'white',
                    fontFamily: 'Gilroy-SemiBold',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '0.5rem',
                    fontSize: '1rem',
                  }}
                  onClick={() => window.open('https://api.whatsapp.com/send/?phone=6285190013535', '_blank')}
                >
                  Hubungi Electrum <ArrowRight fill="#fff" />
                </button>
              </div>
              {/* <div>
                <button style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#0B4571',
                  border: 'none',
                  color: 'white',
                  fontFamily: 'Gilroy-SemiBold',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                }}>
                  Jelajahi Lokasi Electrum <ArrowRight fill="#fff" />
                </button>
              </div> */}
              {/* <div>
                <button style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: 'white',
                  border: 'none',
                  color: '#0B4571',
                  fontFamily: 'Gilroy-SemiBold',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '0.5rem',
                  fontSize: '1rem',
                }}>
                  Hubungi Electrum <ArrowRight fill="#fff" />
                </button>
              </div> */}
            </div>
          </div>
          {/* RIGHT */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ fontFamily: 'Gilroy-ExtraBold', fontSize: '2.25rem', color: '#103856', marginBottom: '1.5rem' }}>
              Alamat Lengkap Showroom
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: '1rem' }}>
              <div style={{ fontFamily: 'Gilroy-SemiBold', fontSize: '1.125rem', color: '#71869C' }}>
                Jl. Sultan Iskandar Muda No.Kav.29, RT.7/RW.9, Pondok Indah, Kec. Kby. Lama, Jakarta Selatan 12240
              </div>
              <div style={{ fontFamily: 'Gilroy-SemiBold', fontSize: '1.125rem', color: '#71869C' }}>
                Senin-Jumat	09.00-17.00 <br />
                Sabtu 09.00-13.00 <br />
                Minggu Libur
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* DRIVER RENT */}
      <div style={{ margin: '6rem 12.5rem', padding: '3rem', backgroundColor: 'white', borderRadius: '1.875rem' }}>
        <div style={{ fontFamily: 'Gilroy-ExtraBold', fontSize: '2.25rem', marginBottom: '1rem' }}>
          Sewa Khusus Mitra Driver
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
          <div style={{ fontFamily: 'Gilroy-Semibold', color: '#71869C', maxWidth: '40%' }}>
            Dapatkan penawaran khusus untuk mitra driver ojek online melalui skema penyewaan bulanan motor listrik Electrum.
          </div>
          <div>
            <button
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                backgroundColor: '#0B4571',
                border: 'none',
                color: 'white',
                fontFamily: 'Gilroy-SemiBold',
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem',
                fontSize: '1rem',
              }}
              onClick={() => window.open('https://opsapp.id/registrasi_electrum', '_blank')}
            >
              Sewa Electrum <ArrowRight fill="#fff" />
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default AboutUs
